"use strict";
/**
 * Interfaces description https://piste.gouv.fr/index.php?option=com_apiportal&view=apitester&usage=api&apitab=tests&apiName=JUDILIBRE&apiId=b6d2f389-c3ec-4eb3-9075-bc24d0783781&managerId=2&type=rest&apiVersion=1.0.0&Itemid=402&swaggerVersion=2.0&lang=fr
 * Use credentials from Livv 1password to login to https://piste.gouv.fr/ and access this documentation
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.citiesMapping = exports.resultCAMapping = exports.resultCCMapping = exports.decisionTypeCAMapping = exports.decisionTypeCCMapping = exports.publicationCCMapping = exports.juridictionRoomCCMapping = exports.jurisdictionShortMapping = exports.jurisdictionNameMapping = void 0;
exports.jurisdictionNameMapping = {
    cc: 'COUR DE CASSATION',
    ca: "COUR D'APPEL",
    tj: 'TRIBUNAL JUDICIAIRE',
};
exports.jurisdictionShortMapping = {
    cc: 'Cass.',
    ca: 'CA',
    tj: 'TJ',
};
exports.juridictionRoomCCMapping = {
    pl: 'ASSEMBLEE PLENIERE',
    mi: 'CHAMBRE MIXTE',
    civ1: '1re CHAMBRE CIVILE',
    civ2: '2e CHAMBRE CIVILE',
    civ3: '3e CHAMBRE CIVILE',
    comm: 'CHAMBRE COMMERCIALE',
    soc: 'CHAMBRE SOCIALE',
    cr: 'CHAMBRE CRIMINELLE',
    creun: 'CHAMBRES REUNIES',
    allciv: 'CHAMBRE CIVILE',
};
/**
 * Only b "Publié au Bulletin " is considered as published.
 * CA decisions do not have publication status.
 */
exports.publicationCCMapping = {
    b: 'Publié',
    r: 'Inédit',
    l: 'Inédit',
    c: 'Inédit',
    n: 'Inédit',
};
exports.decisionTypeCCMapping = {
    arret: 'Arrêt',
    avis: 'Avis',
    qpc: 'QPC', // added
    ordonnance: 'Ordonnance', // added
    other: 'Autre', // added
};
exports.decisionTypeCAMapping = {
    arret: 'Arrêt',
    ordonnance: 'Ordonnance',
    other: 'Autre', // added
};
/**
 * New values are added to the CC decision schemas to completely align with
 * Judilibre API.
 */
exports.resultCCMapping = {
    cassation: 'Cassation',
    rejet: 'Rejet',
    annulation: 'Annulation',
    avis: 'Avis',
    decheance: 'Déchéance',
    designation: 'Désignation de juridiction',
    irrecevabilite: 'Irrecevabilité',
    nonlieu: 'Non-lieu à statuer',
    qpc: 'QPC renvoi',
    qpcother: 'QPC autres',
    rabat: 'Rabat',
    renvoi: 'Renvoi',
    other: 'Autre',
};
/**
 * @param solutionAlt - corresponds to solution_alt in DecisionShort
 * @description
 * In judilibre API, all CA decisions have `other` for `solution` key. Sometimes
 * CA decisions have a non-standardized solution_alt key that can be used to
 * to infer the result of the decision.
 * @returns ResultCA value
 */
var resultCAMapping = function (solutionAlt) {
    if (solutionAlt) {
        if (/partielle/i.test(solutionAlt)) {
            return 'Infirmation partielle';
        }
        if (/confirm/i.test(solutionAlt)) {
            return 'Confirmation';
        }
        if (/infirm/i.test(solutionAlt)) {
            return 'Infirmation';
        }
    }
    return 'Autre';
};
exports.resultCAMapping = resultCAMapping;
exports.citiesMapping = {
    ca_agen: 'AGEN',
    ca_aix_provence: 'AIX-EN-PROVENCE',
    ca_amiens: 'AMIENS',
    ca_angers: 'ANGERS',
    ca_basse_terre: 'BASSE-TERRE',
    ca_bastia: 'BASTIA',
    ca_besancon: 'BESANÇON',
    ca_bordeaux: 'BORDEAUX',
    ca_bourges: 'BOURGES',
    ca_caen: 'CAEN',
    ca_cayenne: 'CAYENNE',
    ca_chambery: 'CHAMBÉRY',
    ca_colmar: 'COLMAR',
    ca_dijon: 'DIJON',
    ca_douai: 'DOUAI',
    ca_fort_de_france: 'FORT-DE-FRANCE',
    ca_grenoble: 'GRENOBLE',
    ca_limoges: 'LIMOGES',
    ca_lyon: 'LYON',
    ca_metz: 'METZ',
    ca_montpellier: 'MONTPELLIER',
    ca_nancy: 'NANCY',
    ca_nimes: 'NÎMES',
    ca_noumea: 'NOUMÉA',
    ca_orleans: 'ORLÉANS',
    ca_papeete: 'PAPEETE',
    ca_paris: 'PARIS',
    ca_pau: 'PAU',
    ca_poitiers: 'POITIERS',
    ca_reims: 'REIMS',
    ca_rennes: 'RENNES',
    ca_riom: 'RIOM',
    ca_rouen: 'ROUEN',
    ca_st_denis_reunion: 'SAINT-DENIS DE LA RÉUNION',
    ca_toulouse: 'TOULOUSE',
    ca_versailles: 'VERSAILLES',
};
//# sourceMappingURL=decisionsJudilibre.js.map